import { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import axios from 'axios'
import { Helmet } from 'react-helmet'

import 'normalize.css'
import './style.css'

import Modal from 'Components/Modal'

import LoadingContext from './Contexts/LoadingContext'
import ModalContext from './Contexts/ModalContext'

import './axiosConfig'
import theme from './theme'
import routes from './routes'

const router = createBrowserRouter(routes)

axios.defaults.headers.common['Accept'] = 'application/json'

// axios
// 	.get('https://cliffordpower.com', { responseType: 'text' })
// 	.then((response) => {
// 		const parser = new DOMParser()
// 		const doc = parser.parseFromString(response.data, 'text/html')

// 		const footer = doc.querySelector('#genesis-footer-widgets')
// 		if (!footer) {

// 			return
// 		}

// 		document.body.appendChild(footer)
// 	})

const Root = () => {
	const [loading, setLoading] = useState()
	const [modal, setModal] = useState()

	useEffect(() => {
		const requestInterceptor = axios.interceptors.request.use((config) => {
			setLoading(true)
			return config
		})

		const responseInterceptor = axios.interceptors.response.use(
			(response) => {
				setLoading(false)
				return response
			},
			(error) => {
				setLoading(false)
				return Promise.reject(error)
			}
		)

		return () => {
			axios.interceptors.request.eject(requestInterceptor)
			axios.interceptors.response.eject(responseInterceptor)
		}
	}, [])

	return (
		<LoadingContext.Provider value={{ loading, setLoading }}>
			<ModalContext.Provider value={{ modal, setModal }}>
				<ThemeProvider theme={theme}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Helmet>
							<title>Service Sync Compliance Docs CPS</title>
						</Helmet>
						<RouterProvider router={router} />
						<Modal modal={modal} setModal={setModal} />
					</LocalizationProvider>
				</ThemeProvider>
			</ModalContext.Provider>
		</LoadingContext.Provider>
	)
}

const root = createRoot(document.getElementById('root'))
root.render(<Root />)
